export default __webpack_public_path__ + "static/media/meter2.c8aacb31.jpg";